import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import { createResource } from '@atlassian/react-resource-router';
import { RESOURCE_TYPE_ARJ_SETTINGS_FINANCIAL_YEAR } from './constants.tsx';
import type { FinancialYearResponse } from './types.tsx';

export const arjSettingsFinancialYearResource = createResource<FinancialYearResponse>({
	type: RESOURCE_TYPE_ARJ_SETTINGS_FINANCIAL_YEAR,
	getKey: () => 'financial-year-information',
	getData: async () => fetchJson('/rest/jpo/1.0/fiscalYear'),
	maxAge: 0,
});
